import React from 'react';
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

export function OfflineBanner() {
  const isOnline = useOnlineStatus();
  if (isOnline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-center gap-2 py-2 text-xs font-medium"
      style={{ background: '#1A3A33', color: '#EDF4F2' }}
    >
      <WifiOff size={13} />
      You're offline — showing last loaded data. Changes will sync when you reconnect.
    </div>
  );
}
